import { useState, useEffect } from "react";
import { StyleSheet, View, Text } from "react-native";

import { FONT } from "../../../value/staticValues";
import { PLATFORM_URL } from "../../../value/Url";
import { requests } from "../../../common/RestAPI";
import { CustomTextInput, TextArea } from "../../base/CustomInputText";
import { ReactComponent as MsgInfoImg } from '../../../img/ico-msg-info-2.svg';
import { useTranslation } from "react-i18next";
import { ReactComponent as NormalImg } from "../../../img/ico-account-sleeper.svg";
import { ReactComponent as IdleImg } from "../../../img/ico-account-idle.svg";
import { ReactComponent as LockImg } from "../../../img/ico-account-lock.svg";
import { ReactComponent as StatusStableImg} from "../../../img/ico-status-stable.svg";
import { ReactComponent as StatusBlockImg } from "../../../img/ico-status-block.svg";
import { ClusterData } from "./ClusterData";

interface ArgsType {
    container_cluster_id: string;
    container_cluster_name: string;
    container_cluster_description: string;
    node_count: number;
    master_node_count: number;
    container_cluster_health_yn: boolean;
    container_cluster_status_code: string;
    status_reason: string;
    health_reason: string;
}


interface ClusterUpdateProps {
    showMessageCb?: Function,
    showLoadingCb?: Function,
    showSlideModalCb?: Function,
    stepIndex: number,
    clickedConfirmYn: boolean,
    resultCb?: Function,
    stepCount: number,
    args?: ArgsType,
};


ClusterUpdate.defaultProps = {
    stepIndex: 0,
    clickedConfirmYn: false,
    stepCount: 1,
}


export default function ClusterUpdate(props:ClusterUpdateProps) {
    const { t } = useTranslation();

    const [stepIndex, setStepIndex] = useState(0);
    const [executeUpdateYn, setExecuteUpdateYn] = useState(false);
    const [detailData, setDetailData] = useState<ClusterData>();
    const [nodeCount, setNodeCount] = useState("0");
    const [nodeCountWarnYn, setNodeCountWarnYn] = useState(false);


    useEffect(() => {
        if(props.showMessageCb) {
            props.showMessageCb("");
        }
        setStepIndex(props.stepIndex);
    }, [props.stepIndex]);

    useEffect(() => {
        if(stepIndex === 0) {
            loadCluster();
        }
    }, [stepIndex])

    useEffect(() => {
        if(props.clickedConfirmYn === true) {
            if(stepIndex < props.stepCount - 1) {
                if(stepIndex === 0) {

                }
            } else {
                const successYn = checkClusterData();
                if(successYn) {
                    setExecuteUpdateYn(true);
                }
            }
        }
    }, [props.clickedConfirmYn]);


    useEffect(() => {
        if(executeUpdateYn) {
            executeUpdateCluster();
        }
    }, [executeUpdateYn]);



    function loadCluster() {
        if(props.showLoadingCb) {
            props.showLoadingCb(true);
        }
        
        requests.get(PLATFORM_URL.CONTAINER_CLUSETER + '/' + props.args?.container_cluster_id)
        .then((response) => {
            if (response.status === 200 && response.data) {
                setDetailData(response.data);
                setNodeCount(response.data.node_count + "");
            }
            if(props.showLoadingCb) {
                props.showLoadingCb(false);
            }
        })
        .catch((error) => {
            if(props.showMessageCb) {
                props.showMessageCb(t("MESSAGE_CANNOT_LOAD_DATA_MESSAGE"));
            }
            if(props.showLoadingCb) {
                props.showLoadingCb(false);
            }
        })
    }

    function checkClusterData() {
        if(props.showMessageCb) {
            props.showMessageCb("");
        }

        setNodeCountWarnYn(false);
        let message = "";
        let error = false;
        if(!nodeCount || Number(nodeCount) === 0) {
            message = t("MESSAGE_CONTAINER_CLUSTER_INFO_ENTER_NODE_COUNT_ERROR_MESSAGE")
            setNodeCountWarnYn(true);
            error = true;
        }
        
        if(props.args?.container_cluster_status_code === "CETPROG" || props.args?.container_cluster_status_code === "UPDTPROG" || props.args?.container_cluster_status_code === "DELPROG" || props.args?.container_cluster_status_code === "RBACKPROG") {
            message = t("MESSAGE_CONTAINER_CLUSTER_STATUS_ERROR_MESSAGE")
            setNodeCountWarnYn(true);
            error = true;
        }
        
        if(error == true) {
            executeResult({}, false, message);
        }

        return !error;
    }


    function executeResult(result, closeYn, infoMessage) {
        setExecuteUpdateYn(false);
        if(props.showMessageCb && infoMessage) {
            props.showMessageCb(infoMessage);
        }
        if(props.resultCb) {
            props.resultCb(result, closeYn);
        }
    }


    function executeUpdateCluster() {
        const body = {
            container_cluster: {
                worker_node_count: Number(nodeCount),
            }
        };

        requests.put(PLATFORM_URL.CONTAINER_CLUSETER + '/' + props.args?.container_cluster_id, body)
        .then((response) => {
            if(response.status === 200) {
                executeResult({successYn: true }, true, "");
            } else {
                executeResult({successYn: false}, false, t("MESSAGE_CANNOT_COMMIT_DATA_MESSAGE"));
            }

        })
        .catch((error) => {
            executeResult({successYn: false}, false, t("MESSAGE_CANNOT_COMMIT_DATA_MESSAGE"));
        });
    }


    return (
        <View>
            {
                stepIndex === 0 ?
                // 이름, 설명, 사용 유형, 사용 대상
                <View>
                    <View style={style.infoBoxContainer}>
                        <MsgInfoImg/>
                        <Text style={style.infoBoxContainerText}>
                            {t("CONTAINER_CLUSTER_UPDATE_INFO_MESSAGE")}
                        </Text>
                    </View>
                    <Text style={style.titleText}>{
                        t("BASE_INFO_TEXT")}
                    </Text>
                    <View style={style.mainContainer}>
                        <View style={style.rowContainer}>
                            <Text style={style.columnText}>
                                {t("CONTAINER_CLUSTER_NAME_TEXT")}
                            </Text>
                            <Text style={style.columeData}>
                                {detailData?.container_cluster_name}
                            </Text>
                        </View>
                        <View style={style.rowContainer}>
                            <Text style={style.columnText}>
                                {t("DESCRIPTION_TEXT")}
                            </Text>
                            <Text style={{...style.columeData, overflow: "hidden"}} numberOfLines={1}>
                                {detailData?.container_cluster_description}
                            </Text>
                        </View>
                        <View style={style.rowContainer}>
                            <Text style={style.columnText}>
                                {t("STATUS_TEXT")}
                            </Text>
                            {
                                !detailData ? null
                                : detailData?.container_cluster_status_code === "CRATCMPT" ? <View style={{flexDirection: "row", alignItems: "center"}}><NormalImg/><Text style={style.columnText}>{t("CREATE_COMPLETE_TEXT")}</Text></View>
                                : detailData?.container_cluster_status_code === "UPDTCMPT" ? <View style={{flexDirection: "row", alignItems: "center"}}><NormalImg/><Text style={style.columnText}>{t("UPDATE_COMPLETE_TEXT")}</Text></View>
                                : detailData?.container_cluster_status_code === "DELCMPT" ? <View style={{flexDirection: "row", alignItems: "center"}}><NormalImg/><Text style={style.columnText}>{t("DELETE_COMPLETE_TEXT")}</Text></View>
                                : detailData?.container_cluster_status_code === "RSUMCMPT" ? <View style={{flexDirection: "row", alignItems: "center"}}><NormalImg/><Text style={style.columnText}>{t("RESUME_COMPLETE_TEXT")}</Text></View>
                                : detailData?.container_cluster_status_code === "RBACKCMPT" ? <View style={{flexDirection: "row", alignItems: "center"}}><NormalImg/><Text style={style.columnText}>{t("ROLLBACK_COMPLETE_TEXT")}</Text></View>
                                : detailData?.container_cluster_status_code === "SNAPCMPT" ? <View style={{flexDirection: "row", alignItems: "center"}}><NormalImg/><Text style={style.columnText}>{t("SNAPSHOT_COMPLETE_TEXT")}</Text></View>
                                : detailData?.container_cluster_status_code === "CHCKCMPT" ? <View style={{flexDirection: "row", alignItems: "center"}}><NormalImg/><Text style={style.columnText}>{t("CHECK_COMPLETE_TEXT")}</Text></View>
                                : detailData?.container_cluster_status_code === "ADPTCMPT" ? <View style={{flexDirection: "row", alignItems: "center"}}><NormalImg/><Text style={style.columnText}>{t("ADAPT_COMPLETE_TEXT")}</Text></View>

                                : detailData?.container_cluster_status_code === "CRTFAIL" ? <View style={{flexDirection: "row", alignItems: "center"}}><IdleImg/><Text style={style.columnText}>{t("CREATE_FAIL_TEXT")}</Text></View>
                                : detailData?.container_cluster_status_code === "UPDTFAIL" ? <View style={{flexDirection: "row", alignItems: "center"}}><IdleImg/><Text style={style.columnText}>{t("UPDATE_FAIL_TEXT")}</Text></View>
                                : detailData?.container_cluster_status_code === "DELFAIL" ? <View style={{flexDirection: "row", alignItems: "center"}}><IdleImg/><Text style={style.columnText}>{t("DELETE_FAIL_TEXT")}</Text></View>
                                : detailData?.container_cluster_status_code === "RSUMFAIL" ? <View style={{flexDirection: "row", alignItems: "center"}}><IdleImg/><Text style={style.columnText}>{t("RESUME_FAIL_TEXT")}</Text></View>
                                : detailData?.container_cluster_status_code === "RBACKFAIL" ? <View style={{flexDirection: "row", alignItems: "center"}}><IdleImg/><Text style={style.columnText}>{t("ROLLBACK_FAIL_TEXT")}</Text></View>

                                : <View style={{flexDirection: "row", alignItems: "center"}}><LockImg/><Text style={style.columnText}>{t("LOCK_TEXT")}</Text></View>
                            }
                        </View>
                        {/* <View style={style.rowContainer}>
                            <Text style={style.columnText}>
                                {t("CONTAINER_CLUSTER_HEALTH_TEXT")}
                            </Text>
                            {!detailData? null :detailData?.container_cluster_health_yn ? <StatusStableImg/> : <StatusBlockImg/>}
                            <Text style={style.columeData}>
                            {!detailData? null : detailData?.container_cluster_health_yn ? "Active" : "Down"}
                            </Text>
                        </View> */}
                        <View style={style.rowTopAlignContainer}>
                            <Text style={style.columnText}>
                                {t("STATUS_REASON_TEXT")}
                            </Text>
                            <Text style={{...style.columeData}}>
                                {detailData?.stack_status_reason ? detailData?.stack_status_reason.substring(0, detailData?.stack_status_reason.indexOf('(HTTP')): ""}
                            </Text>
                        </View>
                        <Text style={{...style.rowDescribeContainer, marginBottom: 20}}>
                            {t("DESCRIBE_CONTAINER_CLUSTER_STACK_STATUS")}
                        </Text>
                        <Text style={{...style.rowDescribeContainer, marginBottom: 20}}>
                            {t("DESCRIBE_CONTAINER_CLUSTER_UNHEALTHY")}
                        </Text>
                        <View style={style.rowDivContainer}/>
                        <View style={style.rowContainer}>
                            <Text style={style.columnText}>
                                {t("CONTAINER_CLUSTER_MASTER_COUNT")}
                            </Text>
                            <Text style={style.columeData}>
                                {detailData?.master_node_count}
                            </Text>
                        </View>
                        <View style={style.rowContainer}>
                            <Text style={style.columnText}>
                                {t("CONTAINER_CLUSTER_NODE_COUNT")}
                            </Text>
                            {
                                detailData ?
                            <CustomTextInput
                                key={4}
                                width={570} height={36}
                                value={nodeCount || "0"}
                                type={"number"}
                                activeYn={true}
                                inputCb={setNodeCount}
                                warnYn={nodeCountWarnYn}
                                placeHolderText={t("1")}
                            /> : null
                            }
                        </View>
                        <Text style={{...style.rowDescribeContainer, marginBottom: 20}}>
                            {t("DESCRIBE_CONTAINER_CLUSTER_NODE_UPDATE_SELECT")}
                        </Text>
                    </View>
                </View>
                : null
            }
        </View>
    );
}


const style = StyleSheet.create({
    titleText: {
        marginTop: 40,
        fontFamily: FONT.MEDIUM,
        fontSize: 14,
        fontWeight: "500",
        color: "#0853fb",

    },
    mainContainer: {
        marginTop: 38
    },
    rowContainer: {
        height: 36,
        flexDirection: "row",
        marginBottom: 30,
        alignItems: "center"
    },
    rowTopAlignContainer: {
        minHeight: 36,
        flexDirection: "row",
        marginBottom: 30,
    },
    rowDivContainer: {
        borderStyle: "solid",
        borderBottomWidth: 1,
        borderBottomColor: "#eee",
        marginBottom: 30,
    },
    rowDescribeContainer: {
        marginLeft: 150, marginTop: -10, marginBottom: 40,
        fontFamily: FONT.REGULAR,
        fontSize: 12,
        color: "#8c8c8c"
    },
    columnText: {
        width: 150,
        fontFamily: FONT.REGULAR,
        fontSize: 13,
        color: "#333",
    },
    infoBoxContainer: {
        flexDirection: "row", alignItems: "center",
        width: 700, height: 58,
        paddingLeft: 10, paddingRight: 10,
        marginBottom: 15,
        borderRadius: 2,
        backgroundColor: "#fafafa"
    },
    infoBoxContainerText: {
        marginLeft: 10,
        fontFamily: FONT.REGULAR,
        fontSize: 12,
        lineHeight: 18,
        color: "#9ea0a5"
    },
    columeData: {
        width: 550,
        fontFamily: FONT.REGULAR,
        fontSize: 13,
        color: "#333",
        overflow: "scroll"
    },
});


const labelStyle = {
    fontFamily: FONT.REGULAR,
    fontSize: 12,
    color: "#333"
}